import React from "react";

const LOGO_SRC = "/images/ecoption-supply-logo.webp";

export default function Logo({ forceVariant, className = "", showTagline = false }) {
  const onDarkBackground = forceVariant === "dark";

  return (
    <span className={`inline-flex flex-col items-start ${className}`}>
      <span className={onDarkBackground ? "inline-flex rounded-xl bg-white px-3 py-2" : "inline-flex"}>
        <img
          src={LOGO_SRC}
          alt="Ecoption Supply"
          className="h-11 sm:h-12 w-auto object-contain"
          width="805"
          height="251"
          decoding="async"
        />
      </span>
      {showTagline && (
        <span className="mt-3 text-[9px] uppercase tracking-[0.18em] font-semibold text-slate-400">
          Consumíveis &amp; Fornecimento Empresarial
        </span>
      )}
    </span>
  );
}
